import Vue from "vue";
import conf from "./brands";
import TipoConsulta from "@/views/TipoConsulta";
import TipoConsultaEmpresas from "@/views/TipoConsultaEmpresas";
import TipoConsultaLibroDeQuejas from "@/views/TipoConsultaLibroDeQuejas";
import Gracias from "@/views/Gracias";
import TipoConsultaAltaDigital from "@/views/TipoConsultaAltaDigital";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto";
import Error from "@/views/Error";
import router from "@/router";

const values = {};

const config = {
  install(Vue) {
    Vue.mixin({
      mounted() {},
      computed: {
        config() {
          return this.$config.get();
        }
      }
    });
  },
  start(_callback) {
    // Voy a buscar la config del Branding
    // Guardo la config en la instancia local
    values.json = conf;

    function getRootComponent() {
      switch (_BBVA_CAMP) {
        case "ofertaDigital":
          return TipoConsulta;
        case "ofertaEmpresas":
          return TipoConsultaEmpresas;
        case "ofertaLibroDeQuejas":
          return TipoConsultaLibroDeQuejas;
        default:
          // Si _BBVA_CAMP no coincide con ninguno de los casos anteriores,
          // se usa TipoConsultaAltaDigital como valor por defecto.
          return TipoConsultaAltaDigital;
      }
    }

    const routes = [
      {
        path: "/",
        // Asigna el componente retornado por la función auxiliar
        component: getRootComponent()
      },
      {
        name: "gracias",
        path: "/gracias/:tipoGracias",
        component: Gracias,
        props: true
      },
      {
        name: "error",
        path: "/error",
        component: Error
      }
    ];

    for (const key in values.json.vistas) {
      // eslint-disable-next-line no-prototype-builtins
      if (values.json.vistas.hasOwnProperty(key)) {
        const element = values.json.vistas[key];
        const productLabel = element.label;

        /** Guardo el route name para usar en las vistas */
        element.routeName = key;

        /** Guardar ruta principal de tipo de consulta */
        routes.push({
          name: element.routeName,
          path: `/${key}`,
          meta: {
            levelsShort: [key],
            levels: [element.routeName]
          },
          components: {
            default: TipoConsulta,
            tipoConsulta: () => import(`@/views/segments/${element.segment}`)
          }
        });

        /** Ver si hay sub-segments */
        // eslint-disable-next-line no-prototype-builtins
        if (element.hasOwnProperty("items")) {
          for (const itemKey in element.items) {
            // eslint-disable-next-line no-prototype-builtins
            if (element.items.hasOwnProperty(itemKey)) {
              const subElement = element.items[itemKey];

              /** Guardo el route name para usar en las vistas */
              subElement.routeName = `${key}-${itemKey}`;
              let motivoLabel = "";
              if (Object.prototype.hasOwnProperty.call(subElement, "label")) {
                motivoLabel = element.items[itemKey].label;
              }
              /** Ver si hay un 3er nivel de sub-segments */
              // eslint-disable-next-line no-prototype-builtins
              if (subElement.hasOwnProperty("items")) {
                for (const subItemKey in subElement.items) {
                  // eslint-disable-next-line no-prototype-builtins
                  if (subElement.items.hasOwnProperty(subItemKey)) {
                    const subSubElement = subElement.items[subItemKey];

                    /** Guardo el route name para usar en las vistas */
                    subSubElement.routeName = `${key}-${itemKey}-${subItemKey}`;

                    /** Guardar la ruta del sub-segmento */
                    routes.push({
                      name: subSubElement.routeName,
                      path: `/${key}/${itemKey}/${subItemKey}/:noResolvimos?`,
                      meta: {
                        levelsShort: [key, itemKey, subItemKey],
                        levels: [
                          element.routeName,
                          subElement.routeName,
                          subSubElement.routeName
                        ]
                      },
                      components: {
                        default: TipoConsulta,
                        tipoConsulta: () =>
                          import(`@/views/segments/${element.segment}`),
                        subSegment: subElement.subSegment
                          ? () =>
                              import(
                                `@/views/segments/subSegments/${subElement.subSegment}`
                              )
                          : undefined,
                        help: subSubElement.help
                          ? () =>
                              import(
                                `@/views/segments/help/${subSubElement.help}`
                              )
                          : FormularioContacto
                      }
                    });
                  }
                }
              }

              /** Guardar la ruta del sub-segmento */
              routes.push({
                name: subElement.routeName,
                path: `/${key}/${itemKey}/:noResolvimos?`,
                meta: {
                  levelsShort: [key, itemKey],
                  data: [productLabel, motivoLabel],
                  levels: [element.routeName, subElement.routeName]
                },
                components: {
                  default: TipoConsulta,
                  tipoConsulta: () =>
                    import(`@/views/segments/${element.segment}`),
                  subSegment: subElement.subSegment
                    ? () =>
                        import(
                          `@/views/segments/subSegments/${subElement.subSegment}`
                        )
                    : undefined,
                  help: subElement.help
                    ? () => import(`@/views/segments/help/${subElement.help}`)
                    : undefined
                }
              });
            }
          }
        }
      }
    }

    router.addRoutes(routes);
    _callback();
  },
  get() {
    return values.json;
  }
};

Vue.prototype.$config = config;

export default config;
